import React from 'react';

function PaiePage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Paie</h1>
      <p>Page `fhc-paie.html` convertie en composant React.</p>
    </div>
  );
}

export default PaiePage;
